import { DocumentsKeys } from '@/i18n/types/documents.types';

export const documents: Record<DocumentsKeys, string> = {
  documents: 'Documentos',
  documentsDescription: 'Crea, edita y gestiona documentos de texto con formato enriquecido',
  newDocument: 'Nuevo Documento',
  yourDocuments: 'Tus Documentos',
  createDocument: 'Crear Documento',
  editDocument: 'Editar Documento',
  documentTitle: 'Título del Documento',
  documentContent: 'Contenido del Documento',
  saving: 'Guardando',
  saveDocument: 'Guardar Documento',
  exportToPdf: 'Exportar a PDF',
  openPdf: 'Abrir PDF',
  uploadPdf: 'Cargar PDF',
  titleRequired: 'El título es obligatorio',
  documentCreated: 'Documento Creado',
  documentUpdated: 'Documento Actualizado',
  documentDeleted: 'Documento Eliminado',
  documentCreatedSuccess: 'Tu documento ha sido creado exitosamente',
  documentUpdatedSuccess: 'Tu documento ha sido actualizado exitosamente',
  documentDeletedSuccess: 'Tu documento ha sido eliminado exitosamente',
  deleteDocument: 'Eliminar Documento',
  deleteDocumentConfirmation: '¿Estás seguro que deseas eliminar este documento? Esta acción no se puede deshacer.',
  selectDocumentOrCreateNew: 'Selecciona un documento de la lista o crea uno nuevo',
  noDocumentsYet: 'Aún no hay documentos. Haz clic en el botón "Nuevo Documento" para crear uno.',
  loading: 'Cargando...',
  error: 'Error',
  errorFetchingDocuments: 'Error al cargar los documentos. Por favor, inténtalo de nuevo.',
  errorCreatingDocument: 'Error al crear el documento. Por favor, inténtalo de nuevo.',
  errorUpdatingDocument: 'Error al actualizar el documento. Por favor, inténtalo de nuevo.',
  errorDeletingDocument: 'Error al eliminar el documento. Por favor, inténtalo de nuevo.',
  errorSavingDocument: 'Error al guardar el documento. Por favor, inténtalo de nuevo.',
  mustBeLoggedIn: 'Debes iniciar sesión para realizar esta acción.',
  textProcessor: 'Procesador de Texto',
  pdfViewer: 'Visor de PDF',
  pdfViewerDescription: 'Visualiza y gestiona tus archivos PDF',
  dropPdfFiles: 'Suelta archivos PDF aquí o haz clic para explorar',
  pdfLoadError: 'Error al cargar el archivo PDF',
  pageOf: 'Página {current} de {total}',
  previousPage: 'Página Anterior',
  nextPage: 'Página Siguiente',
  zoomIn: 'Acercar',
  zoomOut: 'Alejar',
  resetZoom: 'Restablecer Zoom',
  downloadPdf: 'Descargar PDF',
  closePdf: 'Cerrar PDF',
  noPdfSelected: 'No hay PDF seleccionado. Carga un archivo PDF para visualizarlo.',
  wordCount: 'Palabras: {count}',
  characterCount: 'Caracteres: {count}',
  printDocument: 'Imprimir Documento',
  openDocument: 'Abrir Documento',
};